import React from 'react';
import PropTypes from 'prop-types';

import { StatusBarWrapper } from './css';
import Desktop from './desktop';

const StatusBar = ({
  isFormTouched,
  isFormValidated,
  dueMonthly = 0,
  dueNow = 0,
  onSaveAndExit,
  onSubmit,
  formErrors,
  hidePricing = false,
  isSubmitting
}) => {
  const getPrice = amount => `$${amount.toFixed(2)}`;

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <Desktop
          isFormTouched={isFormTouched}
          isFormValidated={isFormValidated}
          dueMonthly={getPrice(dueMonthly)}
          dueNow={getPrice(dueNow)}
          onSaveAndExit={onSaveAndExit}
          onSubmit={onSubmit}
          hidePricing={hidePricing}
          formErrors={formErrors}
          isSubmitting={isSubmitting}
        />
      </div>
    </StatusBarWrapper>
  );
};

StatusBar.propTypes = {
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  dueMonthly: PropTypes.number,
  dueNow: PropTypes.number,
  onSaveAndExit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool,
  formErrors: PropTypes.shape({}).isRequired,
  isSubmitting: PropTypes.bool
};

export default StatusBar;
